import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from 'shared/mui/IconButtons';
import { AutocompleteInput } from 'shared/react-admin/Inputs';
import { TextInput } from 'shared/react-admin/Inputs/TextInputs/TextInput/TextInput';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

import {
  PresetItemDescriptionRowStyled,
  PresetItemRowStyled,
} from './PresetsItemsSectionRow.styled';

type Props = {
  name: string;
  index: number;
  onRemove: (index: number) => void;
};

export const PresetsItemsSectionRow: React.FC<Props> = ({ name, index, onRemove }) => {
  return (
    <PresetItemRowStyled>
      <ReferenceInput reference="directions" source={`${name}.${index}.direction`}>
        <AutocompleteInput
          helperText={false}
          label="Направление"
          optionText="description"
          optionValue="@id"
          readOnly
          variant="outlined"
        />
      </ReferenceInput>
      <TextInput
        helperText={false}
        isRequired
        label="Сумма"
        parse={(v) => v.replace(',', '.')}
        source={`${name}.${index}.amount`}
        variant="outlined"
      />
      <ReferenceInput perPage={100} reference="preset_badges" source={`${name}.${index}.badge`}>
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label="Бейдж"
          optionText="description"
          variant="outlined"
        />
      </ReferenceInput>
      <IconButton
        onClick={() => onRemove(index)}
        size="small"
        sx={{ mt: '4px', color: 'error.main' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <PresetItemDescriptionRowStyled>
        <TextInput
          fullWidth
          helperText={false}
          label="Описание"
          source={`${name}.${index}.description`}
          variant="outlined"
        />
      </PresetItemDescriptionRowStyled>
    </PresetItemRowStyled>
  );
};
